import React from 'react';
import { Container } from './styles';

const TextDivider = ({
  text,
  additionalstyle
}) => {
  return (
    <Container additionalstyle={additionalstyle}>
      <div className="line" />
        <span className="text">{text}</span>
      <div className="line" />
    </Container>
  );
};

export default TextDivider;
